import { Link, NavLink, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import '../../styles/navigation.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setMenuOpen(false), [location.pathname, location.hash]);

  return (
    <header className="kc-header">
      <div className="kc-nav-inner">
        <Link to="/" className="kc-brand" aria-label="K-Ching, inicio">
          <img src={require('../../images/logo.png')} alt="" /><span>K-Ching</span>
        </Link>
        <button className="kc-menu-toggle" type="button" aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={menuOpen} onClick={() => setMenuOpen(!menuOpen)}>
          <span /><span /><span />
        </button>
        <nav className={`kc-nav-links ${menuOpen ? 'is-open' : ''}`} aria-label="Navegación principal">
          <NavLink to="/" end>Inicio</NavLink>
          <NavLink to="/servicios">Servicios</NavLink>
          <NavLink to="/proyectos">Proyectos</NavLink>
          <NavLink to="/nosotros">Nosotros</NavLink>
          <Link className="kc-nav-cta" to="/contacto">Iniciar proyecto <span aria-hidden="true">↗</span></Link>
        </nav>
      </div>
    </header>
  );
}
export default Navbar;
